module.exports = __webpack_public_path__ + "img/meeting_room.d182f769.png";